import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';

function PrivateRoute({ children }) {
  const { isAuthenticated, isCheckingAuth, activated } = useContext(AuthContext);
  const location = useLocation();

  // Show loading state while checking authentication
  if (isCheckingAuth) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Checking authentication...</div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Signed in but not yet switched on: the waiting-room page.
  if (!activated) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}

export default PrivateRoute;
